import script from "./switch-toggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./switch-toggle.vue?vue&type=script&setup=true&lang=ts"

import "./switch-toggle.vue?vue&type=style&index=0&id=3c774581&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c774581"]])

export default __exports__